import React, { useEffect, useState } from 'react'
import { NewCommonModal, CustomSelect } from 'components'

const PermissionModal = (props) => {
    let { message = `You don't have permissions.` } = props;

    return (
        <div>
            <NewCommonModal {...props}>
                <div className='addLr_body mt-2'>
                    {message}
                </div>
            </NewCommonModal>
            <div className='offBack_drop'></div>
        </div>
    )
}

export default PermissionModal
